module.exports = __webpack_public_path__ + "img/otros-servicios-transporte.a44a755e.jpg";